var React = require('react');

function IconCloseBorder (props) {
    return React.createElement("svg",props,[React.createElement("path",{"stroke":"currentColor","d":"M12 23.5c6.351 0 11.5-5.149 11.5-11.5S18.351.5 12 .5.5 5.649.5 12 5.649 23.5 12 23.5Z","key":0}),React.createElement("path",{"stroke":"currentColor","strokeLinecap":"round","d":"m7.41 16 8.641-8.643M16.408 16 7.767 7.357","key":1})]);
}

IconCloseBorder.defaultProps = {"width":"24","height":"24","fill":"none","viewBox":"0 0 24 24"};

module.exports = IconCloseBorder;

IconCloseBorder.default = IconCloseBorder;
